// Specialized form field for email inputs
import React from 'react';
import { FormField } from './FormField';
import { TextInputProps } from 'react-native';

interface EmailFormFieldProps extends Omit<TextInputProps, 'keyboardType' | 'autoCapitalize'> {
  label: string;
  error?: string;
  required?: boolean;
  helpText?: string;
}

export const EmailFormField: React.FC<EmailFormFieldProps> = (props) => {
  return (
    <FormField
      {...props}
      keyboardType="email-address"
      autoCapitalize="none"
    />
  );
};

